import { SvgIconComponent } from "@mui/icons-material";
import {
  ExecutivoIcon,
  PendenciasIcon,
  PerformanceIcon,
  SearchCpfIcon,
} from "../insightsIcons";

/**
 * O ícone de cada relatório, reaproveitando os mesmos do painel (`insightsIcons`)
 * para que um relatório e o atalho equivalente no chat não apareçam com
 * desenhos diferentes.
 *
 * Isto **não** é um catálogo paralelo: quem manda no que existe continua sendo
 * o `GET /insights/reports`. Um relatório novo no backend aparece na tela sem
 * tocar aqui — só cai no ícone padrão até alguém escolher um melhor.
 */
const ICONS: Record<string, SvgIconComponent> = {
  "cobertura-confirmada": ExecutivoIcon,
  "movimentacoes-periodo": PerformanceIcon,
  "timeline-cpf": SearchCpfIcon,
};

export function reportIcon(reportId: string): SvgIconComponent {
  return ICONS[reportId] ?? PendenciasIcon;
}
